import React, { useState, useCallback, useEffect, useRef, useMemo } from "react";
import { useHistory } from 'react-router-dom';
import { connect } from "react-redux";
import { Button } from 'devextreme-react/button';
import axios from "axios";
import { TabPanel, Item as TabItem } from 'devextreme-react/tab-panel';
import { LoadPanel } from 'devextreme-react/load-panel';
import notify from 'devextreme/ui/notify';
import { alert, confirm } from 'devextreme/ui/dialog';
import Toolbar, { Item } from "devextreme-react/toolbar";
import { custom } from 'devextreme/ui/dialog';
import ValidationSummary from 'devextreme-react/validation-summary';
import TransactionTab from "./tabs/CommonTab";
import PrimaryTab from "./tabs/PrimaryTab";
import CommonTab from "./tabs/CommonTab";
import {TransctionLayout,
    ItemsLayout,
    MiscLayout,
    ShipperConsigneeLayout,
    SerialLayout,
    OwnershipTransferLayout } from './Layouts';
import TransactionEntryTab from "./tabs/TransactionEntryTab";

function Form(props) {
    var currentUser = props.oidc.user;
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    const initialFormFields = {
        ROWID: '00000000-0000-0000-0000-000000000000',
        KEYCODE: 1,
        CREATIONDATETIME: null,
        CREATIONUSERID: null,
        LASTUPDATEDATETIME: null,
        LASTUPDATEUSERID: null,
        COMPANYID: null,
        MODULE: "WM",
        RECORDTYPE: null,
        R_TRANSACTIONPROFILE: null,
        R_ITEMPROFILE: null,
        COMMENT: null,
        UPDATEITEMSTATUS: null,
        SHOWCURRENTLOTONLY: null,
        SHOWCURRENTSUBLOTONLY: null,
        ADDITIONAL: null,
        SCHEDULE: 'Y',
        TRANSPORTATION: 'Y',
        LABORTRACKING: 'Y',
        USERDEFINED: 'Y',
        CURRENCY: 'Y',
        TRANSCHARGES: 'Y',
        PALLETTRACKING: 'Y',
        CREATESSCC: null,
        STDTOMETRICTONCONVERSIONFACTOR: null,
        BOLSHOWPREVIEW: null,
        BOLPRINTCOPIES: null,
        UPDATESTAGEFLD: 'N',
        CREATETRANSACTIONCHARGES: 'N',
        AUTOLOADTRANSDATA: null,
        OTCREATEITEMFROMPROFILE: 'P',
        APIMSGS: 'Y',
        RFAUDITMSGS: 'Y',
        INSPECTION: 'Y',
        CANCELLEDITEMS: null,
        ITEMLOTUPDATE: 'Y',
        UNCOMMITMAXLIMIT: null,
        PROSHIPEXEPATH: null,
        PROSHIPPRINTER: null,
        STAGEUPSECURITY: null,
        STAGEDOWNSECURITY: null,
        ScheduleRole: null,
        R_RECEIPTPROFILE: null,
        R_SHIPMENTPROFILE: null,
    };

    const history = useHistory();
    var accessToken = props.oidc.user.access_token;
    const [loadPanelVisible, setLoadPanelVisible] = useState(false);
    const [isFormSubmitted, setIsFormSubmitted] = useState(false);
    const [formFields, setformFields] = useState(initialFormFields);
    const formFieldsRef = useRef(formFields);
    const [roles, setRoles] = useState(null);
    const [globalRoles, setGlobalRoles] = useState(null);

    const hideLoadPanel = useCallback(() => {
        setLoadPanelVisible(false);
    }, [setLoadPanelVisible]);
    const position = { of: '#accordion-containe2' };
    const formRefs = useRef({});

    const handleFormSubmit = async (e) => {
        setLoadPanelVisible(true);
        setIsFormSubmitted(true);
        try {
            e.preventDefault();
            await updateItem();
        } catch (error) {
            console.error('Error submitting form:', error);
            setIsFormSubmitted(false);
        } finally {
            setTimeout(hideLoadPanel, 1000);

        }
    };
    useEffect(() => {
        if(roles){
        const filteredRoles = roles
            .filter(role =>
                role.RoleName.startsWith("abecas_a") || role.RoleName.startsWith("abecas_b")
            )
            .map(role => {
                let displayName = role.RoleName
                    .replace("abecas", "")
                    .replace(/_a|_b/g, " ")
                    .replace(/_/g, " ")
                    .trim(); 

                return {
                    ...role,
                    RoleName: displayName
                };
            })
            .sort((a, b) => a.RoleName.localeCompare(b.RoleName));
            filteredRoles.push({
                RoleName: "public",
                OriginalRoleName:"public",
                RoleId: "public",
            });
        if (formRefs.current["STAGEUPSECURITY"]) {
            formRefs.current["STAGEUPSECURITY"].instance().option('valueExpr', "OriginalRoleName");
            formRefs.current["STAGEUPSECURITY"].instance().option('displayExpr', "RoleName");
            formRefs.current["STAGEUPSECURITY"].instance().option('dataSource', filteredRoles);
        }
        if (formRefs.current["STAGEDOWNSECURITY"]) {
            formRefs.current["STAGEDOWNSECURITY"].instance().option('valueExpr', "OriginalRoleName");
            formRefs.current["STAGEDOWNSECURITY"].instance().option('displayExpr', "RoleName");
            formRefs.current["STAGEDOWNSECURITY"].instance().option('dataSource', filteredRoles);
        }
        }


    }, [roles])

    // The Schedule Role dropdown loads its roles from the global roles source (auth server),
    // the same list shown on the Security > User Security "Roles" tab grid.
    useEffect(() => {
        if (globalRoles && formRefs.current["ScheduleRole"]) {
            formRefs.current["ScheduleRole"].instance().option('valueExpr', "key");
            formRefs.current["ScheduleRole"].instance().option('displayExpr', "key");
            formRefs.current["ScheduleRole"].instance().option('dataSource', globalRoles);
        }
    }, [globalRoles])


    const updateItem = async () => {
        try {
            const url = "wm/Setup/UpdateSetup";
            let fields = formFields;

            const response = await axios.put(`${window._env_.REACT_APP_APIS}/${url}`, fields, {
                headers: {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`
                },
            });
            if (!response.data || !response.data.ERRORS.length > 0) {
                notify(
                    {
                        message: "Setup Updated",
                        width: 100,
                    },
                    'success',
                    3000,
                );
                setIsFormSubmitted(false);
            }


        } catch (error) {
            console.error('Error submitting form:', error);

            if (error.response.data.ERRORS && error.response.data.ERRORS.length > 0) {
                var hasWarning = false;
                var hasConfirmation = false;
                var errorMessage = "";
                var errorsArray = [];

                for (let i = 0; i < error.response.data.ERRORS.length; i++) {

                    if (error.response.data.ERRORS[i].startsWith("[ItemTypeWarning]")) {
                        hasWarning = true;
                        errorMessage = error.response.data.ERRORS[i];
                        errorMessage = errorMessage.replace('[ItemTypeWarning]', '');
                        errorMessage = errorMessage.replace(/(?:\r\n|\r|\n)/g, '<br>');
                    }
                    else if (error.response.data.ERRORS[i].startsWith("[ItemTypeConfirmation]")) {
                        hasConfirmation = true;
                        errorMessage = error.response.data.ERRORS[i];
                        errorMessage = errorMessage.replace('[ItemTypeConfirmation]', '');
                        errorMessage = errorMessage.replace(/(?:\r\n|\r|\n)/g, '<br>');
                    }
                    else {
                        errorsArray.push(error.response.data.ERRORS[i]);
                    }
                }

                if (errorsArray.length > 0) {
                    const errorHtml = errorsArray.map(err => `<div>${err}</div>`).join('');
                    custom({
                        title: "Errors",
                        messageHtml: errorHtml,
                        buttons: [{ text: "OK", onClick: () => { } }]
                    }).show();
                }
            }
            else {
                notify(
                    {
                        message: "Could not create item. An error occurred",
                        width: 100,
                    },
                    'error',
                    3000,
                );
            }

            setIsFormSubmitted(false);
        } finally {
            setTimeout(hideLoadPanel, 1000);

        }
    };

    const primaryFormLoad = () => {

        loadLookupFromStaticData(formRefs, "UPDATEITEMSTATUS", [{ id: 'Y', name: "Yes, Update Lot/Sublot/Unt Status to 'Inactive' if quantities are all zero after commit" }, { id: 'N', name: "No, do not update Status" }]);
        loadLookupFromStaticData(formRefs, "SHOWCURRENTLOTONLY", [{ id: 'N', name: "Show All Lot Records For The Item In The Lot Master Screen" }, { id: 'Y', name: "Only Show Selected Lot Record n The Lot Master Screen" }]);
        loadLookupFromStaticData(formRefs, "SHOWCURRENTSUBLOTONLY", [{ id: 'N', name: "Show All Sublot Records For The Item In The Sublot Master Screen" }, { id: 'Y', name: "Only Show Selected Sublot Record n The Sublot Master Screen" }]);
    }

     const transactionEntryFormLoad = ()=>{
         GetRoles();
         GetGlobalRoles();
         loadLookupFromStaticData(formRefs, "SCHEDULE", [{ id: 'Y', name: "Yes, Show Scheduling Tab in Transaction Entry" }, { id: 'N', name: "No, Do No Show Scheduling Tab in Transaction Entry" }]);
         loadLookupFromStaticData(formRefs, "TRANSPORTATION", [{ id: 'Y', name: "Yes, Show Transportation Tab in Transaction Entry" }, { id: 'N', name: "No, Do No Show Transportation Tab in Transaction Entry" }]);
         loadLookupFromStaticData(formRefs, "LABORTRACKING", [{ id: 'Y', name: "Yes, Show Labor Tracking Tab in Transaction Entry" }, { id: 'N', name: "No, Do No Show Labor Tracking Tab in Transaction Entry" }]);
         loadLookupFromStaticData(formRefs, "USERDEFINED", [{ id: 'Y', name: "Yes, Show User Defined Tab in Transaction Entry" }, { id: 'N', name: "No, Do No Show User Defined Tab in Transaction Entry" }]);
         loadLookupFromStaticData(formRefs, "CURRENCY", [{ id: 'Y', name: "Yes, Show Currency Tab in Transaction Entry" }, { id: 'N', name: "No, Do No Show Currency Tab in Transaction Entry" }]);
         loadLookupFromStaticData(formRefs, "TRANSCHARGES", [{ id: 'Y', name: "Yes, Show Transaction Charges Tab in Transaction Entry" }, { id: 'N', name: "No, Do No Show Transaction Charges Tab in Transaction Entry" }]);
         loadLookupFromStaticData(formRefs, "PALLETTRACKING", [{ id: 'Y', name: "Yes, Show Pallet Tracking Tab in Transaction Entry" }, { id: 'N', name: "No, Do No Show Pallet Tracking Tab in Transaction Entry" }]);
         loadLookupFromStaticData(formRefs, "APIMSGS", [{ id: 'Y', name: "Yes, Show API Msgs Tab in Transaction Entry" }, { id: 'N', name: "No, Do No Show API Msgs Tab in Transaction Entry" }]);
         loadLookupFromStaticData(formRefs, "RFAUDITMSGS", [{ id: 'Y', name: "Yes, Show RF Audit Msgs Tab in Transaction Entry" }, { id: 'N', name: "No, Do No Show RF Audit Msgs Tab in Transaction Entry" }]);
         loadLookupFromStaticData(formRefs, "INSPECTION", [{ id: 'Y', name: "Yes, Show Inspection Tab in Transaction Entry" }, { id: 'N', name: "No, Do No Show Inspection Tab in Transaction Entry" }]);
         loadLookupFromStaticData(formRefs, "CANCELLEDITEMS", [{ id: 'Y', name: "Yes, Show Cancelled Items Tab in Transaction Entry" }, { id: 'N', name: "No, Do No Show Cancelled Items Tab in Transaction Entry" }]);
         loadLookupFromStaticData(formRefs, "ITEMLOTUPDATE", [{ id: 'Y', name: "Yes, Show Lot Update Tab" }, { id: 'N', name: "No, Do No Show Lot Update Tab" }]);

         loadLookupFromStaticData(formRefs, "CREATETRANSACTIONCHARGES", [{ id: 'N', name: "Do not create on commited transactions" }, { id: 'Y', name: "Allow auto create on commited transactions" }]);
         loadLookupFromStaticData(formRefs, "UPDATESTAGEFLD", [{ id: 'N', name: "N/A" }, { id: 'A', name: "Trans Hder UDR-1" }]);
         loadLookupFromStaticData(formRefs, "OTCREATEITEMFROMPROFILE", [{ id: 'N', name: "No, do not create items in OT" },{ id: 'P', name: "Yes, create items based on profile settings" }]);
     }
    const loadLookupFromStaticData = (formRefs, name, dataSource) => {
        if (formRefs.current[name]) {
            formRefs.current[name].instance().option('dataSource', dataSource);
            formRefs.current[name].instance().option('valueExpr', 'id');
            formRefs.current[name].instance().option('displayExpr', 'name');
            if (formFields[name])
                formRefs.current[name].instance().option('value', formFields[name]);
        }

    };



    const GetHeaderInfo = () => {
        try {
            setLoadPanelVisible(true);
            axios.get(`${window._env_.REACT_APP_APIS}/wm/Setup/GetSetupDataByRowId`, {
                headers: {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`
                }
            }).then((res) => {
                const responseData = res.data;

                if (responseData.ROWID) {
                    setformFields(responseData);
                }
                else {
                    console.error('Failed to get item data');
                }
            });


        } catch (error) {
            console.error('Error failed to get item data:', error);
        } finally {
            hideLoadPanel();
        }
    };
    const GetRoles = () => {
        try {
            setLoadPanelVisible(true);
            axios.get(`${window._env_.REACT_APP_APIS}/wm/Setup/GetRolesList`, {
                headers: {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`
                }
            }).then((res) => {
                const responseData = res.data;
                setRoles(responseData);

            });


        } catch (error) {
            console.error('Error failed to get item data:', error);
        } finally {
            hideLoadPanel();
        }
    };
    // Global roles from the auth server — same source as the Security > User Security "Roles" grid.
    const GetGlobalRoles = () => {
        try {
            axios.get(`${window._env_.REACT_APP_AUTH_URL}/Identity/GetGlobalRoles`, {
                headers: {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`
                }
            }).then((res) => {
                setGlobalRoles(res.data);
            });
        } catch (error) {
            console.error('Error failed to get global roles:', error);
        }
    };

    useEffect(() => {

        GetHeaderInfo();

    }, []);

    useEffect(() => {
        formFieldsRef.current = formFields;
    }, [formFields]);


    const handleSelectionChange = useCallback((name, e) => {
    }, []);
    return (
        <div>
            <div className="row dataEntryMainPage">
                <div className="col-md-12 main-page">
                    <div id="accordion">
                        <LoadPanel
                            shadingColor="rgba(0,0,0,0.4)"
                            position={position}
                            onHiding={hideLoadPanel}
                            visible={loadPanelVisible}
                            showIndicator={true}
                            shading={true}
                            showPane={true}
                            hideOnOutsideClick={false}
                        />
                        <form onSubmit={(e) => handleFormSubmit(e)}>
                            <Toolbar className="header">
                                <Item location="before">
                                    <div className="title">
                                        <h6
                                            style={{
                                                color: window._env_.Color2,
                                                marginLeft: '12px'
                                            }}
                                        >
                                            WM Setup Form
                                        </h6>
                                    </div>
                                </Item>
                                <Item location="after">
                                    <Button
                                        text="Save"
                                        useSubmitBehavior={true}
                                        disabled={isFormSubmitted}
                                        type="default"
                                        className="accordianButton"
                                    />
                                </Item>
                            </Toolbar>
                            <TabPanel showNavButtons={true} height={"auto"}>
                                <TabItem title="Primary">
                                    <PrimaryTab formFields={formFields} setformFields={setformFields} primaryFormLoad={primaryFormLoad} formRefs={formRefs} />
                                </TabItem>
                                <TabItem title="Transactions" >
                                    <CommonTab formFields={formFields} setformFields={setformFields} formSchema={TransctionLayout}/>
                                </TabItem>
                                <TabItem title="Items" >
                                    <CommonTab formFields={formFields} setformFields={setformFields} formSchema={ItemsLayout}/>
                                </TabItem>
                                <TabItem title="Serial#/Physical Count" >
                               <CommonTab formFields={formFields} setformFields={setformFields} formSchema={SerialLayout}/>
                                </TabItem>
                                <TabItem title="Ownership Transfer/Crates" >
                                 <CommonTab formFields={formFields} setformFields={setformFields} formSchema={OwnershipTransferLayout}/>
                                </TabItem>
                                <TabItem title="Misc/Storage/Invoices" >
                                 <CommonTab formFields={formFields} setformFields={setformFields} formSchema={MiscLayout}/>
                                </TabItem>
                                <TabItem title="Transaction Entry" >
                                 <TransactionEntryTab formFields={formFields} setformFields={setformFields} transactionEntryFormLoad={transactionEntryFormLoad} formRefs={formRefs} />
                                </TabItem>
                                <TabItem title="Shipper Consignee" >
                                <CommonTab formFields={formFields} setformFields={setformFields} formSchema={ShipperConsigneeLayout}/>
                                </TabItem>
                            </TabPanel>
                            <div className="row">
                                <ValidationSummary className="pl-3 pt-1" id="summary" />
                            </div>
                        </form>
                    </div>

                </div>
            </div>

        </div>
    );
}
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(Form);
